import { DollarSign, Activity, Server, Users, ShieldCheck } from 'lucide-react';

const NAV_CLS = 'px-3 py-1.5 rounded-full text-xs border border-border bg-card hover:bg-muted transition-colors flex items-center gap-1.5';

export const SectionNav = () => (
  <nav className="flex flex-wrap gap-1.5 sm:gap-2 -mt-2" data-testid="section-nav">
    <a href="#market" className={NAV_CLS} data-testid="nav-section-market">
      <DollarSign className="w-3.5 h-3.5 text-emerald-500" /> Market
    </a>
    <a href="#activity" className={NAV_CLS} data-testid="nav-section-activity">
      <Activity className="w-3.5 h-3.5 text-blue-500" /> Activity
    </a>
    <a href="#network" className={NAV_CLS} data-testid="nav-section-network">
      <Server className="w-3.5 h-3.5 text-violet-500" /> Network
    </a>
    <a href="#holders" className={NAV_CLS} data-testid="nav-section-holders">
      <Users className="w-3.5 h-3.5 text-amber-500" /> Holders
    </a>
    <a href="/contracts" className={NAV_CLS} data-testid="nav-section-contracts">
      <ShieldCheck className="w-3.5 h-3.5 text-rose-400" /> Contracts
    </a>
  </nav>
);
